import R from 'app/assets/R'
import { BaseModalComponent } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { useTranslation } from 'react-i18next'
import { FormRoleCommon } from '../hook'
import { useHook } from './hook'
import { IProps } from './type'

export const UpdateModalLayout = (props: IProps) => {
  const { t } = useTranslation()

  const {
    form,
    modalRef,
    handleSubmit,
    isLoading,
    isDefault,
    setIsDefault
  } = useHook(props)

  return (
    <BaseModalComponent
      titleModal={'Cập nhật phân quyền'}
      titleOpenModal={t(R.strings.update)}
      ref={modalRef}
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <FormRoleCommon isDefault={isDefault} onChangeIsDefault={setIsDefault} />
        </BaseForm>
      }
    />
  )
}
